import React, { FC } from "react";
import { IconType } from "./types";

export const SideMenuLeftIcon: FC<IconType> = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.33341 18.3333H0.666748V1.66666H2.33341V18.3333Z"
      fill="white"
      fill-opacity="0.6"
    />
    <path
      d="M18.5001 9.16668H8.35841L13.0167 4.50834L11.8334 3.33334L5.16675 10L11.8334 16.6667L13.0084 15.4917L8.35841 10.8333H18.5001V9.16668Z"
      fill="white"
    />
  </svg>
);
